<template>
  <div>
    <div class="rsu" style="padding:40px;padding-bottom: 100px;">
      <div
        style="background-color: #fff; color: #0C2F53; padding-bottom: 30px; font-size: 24px;font-weight: 700;"
      >
        ข้อมูลแบบฟอร์ม
      </div>
      <div
        style="display:flex;flex-direction: row;justify-content: space-between;height:60px;width:100%;gap:8px;"
      >
        <div style="display: flex;flex-direction: row;gap:8px;width:100%;">
          <div style="width:20%;">
            <div :class="this.applicantstatus >= 1 ? 'cricle-box-active' : 'cricle-box-disable'">
              1
            </div>
          </div>
          <div style="display: flex;flex-direction: column;width:100%;">
            <div
              style="display: flex;flex-direction: row;font-weight: 400;font-size: 16px;justify-content: flex-start; align-items: center;"
              :class="this.applicantstatus >= 1 ? 'text-active' : 'text-disable'"
            >
              <span style="width:-webkit-fill-available;">
                ตรวจสอบ
              </span>
              <span style="position:relative;width:100%">
                <span
                  :class="this.applicantstatus >= 1 ? 'center-line-active' : 'center-line-disable'"
                  style="position:absolute;"
                ></span>
              </span>
            </div>
            <div
              style="font-weight: 400;font-size: 12px;"
              :class="this.applicantstatus >= 1 ? 'text-active' : 'text-disable'"
            >
              ตรวจสอบเอกสาร
            </div>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;gap:8px;width:100%;">
          <div style="width:20%;">
            <div :class="this.applicantstatus >= 2 ? 'cricle-box-active' : 'cricle-box-disable'">
              2
            </div>
          </div>
          <div style="display: flex;flex-direction: column;width:100%;">
            <div
              style="display: flex;flex-direction: row;font-weight: 400;font-size: 16px;justify-content: flex-start; align-items: center;"
              :class="this.applicantstatus >= 2 ? 'text-active' : 'text-disable'"
            >
              <span style="width:-webkit-fill-available;">
                รอเอกสาร
              </span>
              <span style="position:relative;width:100%">
                <span
                  :class="this.applicantstatus >= 2 ? 'center-line-active' : 'center-line-disable'"
                  style="position:absolute;"
                ></span>
              </span>
            </div>
            <div
              style="font-weight: 400;font-size: 12px;"
              :class="this.applicantstatus >= 2 ? 'text-active' : 'text-disable'"
            >
              เอกสารเพิ่มเติม
            </div>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;gap:8px;width:100%;">
          <div style="width:20%;">
            <div :class="this.applicantstatus >= 3 ? 'cricle-box-active' : 'cricle-box-disable'">
              3
            </div>
          </div>
          <div style="display: flex;flex-direction: column;width:100%;">
            <div
              style="display: flex;flex-direction: row;font-weight: 400;font-size: 16px;justify-content: flex-start; align-items: center;"
              :class="this.applicantstatus >= 3 ? 'text-active' : 'text-disable'"
            >
              <span style="width:-webkit-fill-available;">
                ส่งตรวจสอบ
              </span>
              <span style="position:relative;width:50%">
                <span
                  :class="this.applicantstatus >= 3 ? 'center-line-active' : 'center-line-disable'"
                  style="position:absolute;"
                ></span>
              </span>
            </div>
            <div
              style="font-weight: 400;font-size: 12px;"
              :class="this.applicantstatus >= 3 ? 'text-active' : 'text-disable'"
            >
              รอพิจารณา
            </div>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;gap:8px;width:100%;">
          <div style="width:20%;">
            <div :class="this.applicantstatus >= 4 ? 'cricle-box-active' : 'cricle-box-disable'">
              4
            </div>
          </div>
          <div style="display: flex;flex-direction: column;width:100%;">
            <div
              style="display: flex;flex-direction: row;font-weight: 400;font-size: 16px;justify-content: flex-start; align-items: center;"
              :class="this.applicantstatus >= 4 ? 'text-active' : 'text-disable'"
            >
              <span style="width:-webkit-fill-available;">
                เรียบร้อย
              </span>
              <!-- <span style="position:relative;width:100%">
              <span :class="this.applicantstatus >= 2 ? 'center-line-active' : 'center-line-disable'" 
                style="position:absolute;"  
                ></span>
            </span> -->
            </div>
            <div
              style="font-weight: 400;font-size: 12px;"
              :class="this.applicantstatus >= 4 ? 'text-active' : 'text-disable'"
            >
              ตรวจสอบเสร็จสิ้น
            </div>
          </div>
        </div>
      </div>
      <div
        style="display:flex;flex-direction: row; gap:8px;background: #E6F0FB;min-height:160px;width:100%;margin-top:40px;border-radius: 10px;padding: 20px 24px; position: relative;"
      >
        <div style="display:flex;flex-direction: column;gap:8px;">
          <div style="display:flex;flex-direction: row;gap:8px;">
            <div class="text-box-header">
              เลขที่ใบสมัคร :
            </div>
            <div class="text-box=subheader">
              {{ currentdata.projectno }}
            </div>
          </div>
          <div style="display:flex;flex-direction: row;gap:8px;">
            <div class="text-box-header">
              รหัสสมาชิก :
            </div>
            <div class="text-box=subheader">
              {{ currentdata.memberid }}
            </div>
          </div>
          <div style="display:flex;flex-direction: row;gap:8px;">
            <div class="text-box-header">
              ชื่อ-นามสกุล :
            </div>
            <div class="text-box=subheader">
              {{ currentdata.name }}
            </div>
          </div>
          <div style="display:flex;flex-direction: row;gap:8px;">
            <div class="text-box-header">
              โครงการ :
            </div>
            <div class="text-box=subheader">
              {{ currentdata.projectname }}
            </div>
          </div>
        </div>
        <div
          style="display:flex;flex-direction: row;gap:8px;position: absolute;top:12px;right:12px;"
        >
          <img
            @click="goToLivechat"
            src="/static/img/chat.svg"
            style="cursor: pointer;height:40px;width:40px;"
          />
          <img
            @click="deparesendnotifyformbystepid"
            src="/static/img/share.svg"
            style="cursor: pointer;height:40px;width:40px;"
          />
        </div>
      </div>

      <div
        style="display:flex;flex-direction: row;justify-content: flex-end;gap:14px;margin-top:20px; "
      >
        <div v-for="(item, key) in typedata">
          <div v-if="key === index_form">
            <div
              style="width: 32px !important; height: 32px !important; border-radius: 5px !important; border: 1px solid #0C2F53 !important; display: flex; justify-content: center; align-items: center; cursor: pointer;"
              :class="
                _get(stepResult, `[${key}].action`, []) === 'Approve'
                  ? 'bg-green'
                  : _get(stepResult, `[${key}].action`, []) === 'Reject'
                  ? 'bg-red'
                  : ''
              "
            >
              {{ key + 1 }}
            </div>
          </div>
          <div v-else>
            <div
              @click="changIndexForm(key)"
              style="width: 32px !important; height: 32px !important; border-radius: 5px !important; border: 1px solid #D9D9D9 !important; display: flex; justify-content: center; align-items: center; cursor: pointer;"
              :class="
                _get(stepResult, `[${key}].action`, []) === 'Approve'
                  ? 'bg-green'
                  : _get(stepResult, `[${key}].action`, []) === 'Reject'
                  ? 'bg-red'
                  : ''
              "
            >
              {{ key + 1 }}
            </div>
          </div>
        </div>
      </div>
      <div
        style=" display:flex;gap:24px;background-color: #fff;margin-top:18px;margin-bottom: 6px;"
      >
        <span style=" color: #0C2F53;font-size: 20px;font-weight: 700;">
          แบบฟอร์ม
        </span>
        <span style=" color: #0C2F53;font-size: 20px;font-weight: 500;">
          ขั้นที่ {{ index_form + 1 }} - {{ _get(typedata, `${index_form}.name`, []) }}
        </span>
      </div>

      <div>
        <div
          style="padding:20px 52px;border:0px solid #0C2F53;border-radius: 10px 10px 0px 0px;"
          class="color-gradientBlue"
        >
          <div style="color:#fff;font-weight: 700;font-size: 28px;">
            {{ nameForm }}
          </div>
        </div>
        <div
          style="display:flex;flex-direction: column;gap:22px;padding:20px 52px;border:1px solid #0C2F53;border-radius: 0px 0px 10px 10px;"
        >
          <div v-for="(formitem, k) in allform" :key="k" class="form-control">
            <div v-if="['หัวข้อ'].includes(formitem.questiontype)">
              <div style="font-weight: 600;font-size: 20px;color: #2C2C2C;margin-bottom: 10px;">
                {{ formitem.name }}
              </div>
              <v-divider></v-divider>
            </div>
            <div
              v-else-if="formitem.questiontype === 'พารากราฟ' || formitem.questiontype === 'บทความ'"
            >
              <div class="header-form">
                {{ formitem.name }}
              </div>
            </div>
            <div v-else-if="formitem.questiontype === 'ข้อความ'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <input v-model="allform[k].value" class="input-form" />
            </div>

            <div v-else-if="formitem.questiontype === 'หลายตัวเลือก'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <div class="formDetailMember-vradio">
                <v-radio-group v-model="allform[k].value" style="width:100%">
                  <v-radio
                    :key="k"
                    :label="field.label"
                    v-for="(field, k) in formitem.fields"
                    :value="field.label"
                    style="width:100%"
                    color="primary"
                  ></v-radio>

                  <div
                    class="pl-4 pr-4"
                    v-if="subQuestionData(formitem.fields, formitem.value)"
                    style="width:100%"
                  >
                    <FormDetailSubquestion
                      :formdata="{ formitems: subQuestionData(formitem.fields, formitem.value) }"
                      :showPreview="true"
                    ></FormDetailSubquestion>
                  </div>
                </v-radio-group>
              </div>
            </div>

            <div v-else-if="formitem.questiontype === 'เลื่อนลง'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <div class="form-detailmember">
                <v-select
                  class="button-select"
                  v-model="formitem.value"
                  item-text="label"
                  dense
                  outlined
                  :items="formitem.fields.map(item => item)"
                  append-icon="mdi-chevron-down"
                >
                </v-select>
              </div>
            </div>

            <div v-else-if="formitem.questiontype === 'ช่องทำเครื่องหมาย'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <div v-for="(field, k) in formitem.fields" :key="k">
                <v-checkbox
                  :value="field.label"
                  :label="field.label"
                  v-model="formitem.value"
                  class="ma-0 mb-2"
                  outlined
                  hide-details
                  dense
                >
                </v-checkbox>
                <div
                  class="pl-4"
                  v-if="
                    formitem.value &&
                      formitem.value.includes(field.label) &&
                      field.subquestion &&
                      field.subquestion.length
                  "
                >
                  <FormDetailSubquestion
                    :formdata="{ formitems: field.subquestion }"
                    :showPreview="true"
                  ></FormDetailSubquestion>
                </div>
              </div>
            </div>

            <div
              v-else-if="
                ['อัปโหลดเอกสาร', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น'].includes(formitem.questiontype)
              "
            >
              <div>
                <div class="header-form">
                  {{ formitem.name }}
                </div>
                <div class="form-control">
                  <div style="position: relative">
                    <input
                      :value="formitem.value ? formitem.value.length + ' ' + 'ไฟล์' : '0 ไฟล์'"
                      class="depainput rsu pl-5"
                      readonly
                      type="text"
                      style="display:none;"
                    />

                    <UploadDocument
                      v-model="formitem.value"
                      @onUploaded="onClickUploadFile($event)"
                      v-validate="'required'"
                      :multiple="formitem.isMultiple"
                      :showOnlyButton="true"
                    >
                      <template v-slot="{ loading }">
                        <v-btn
                          class="rsu customConfirmBtn ma-0 uploadBtn"
                          round
                          depressed
                          color="primary"
                          :loading="loading"
                        >
                          <img
                            :src="`/static/icon/uploadYellowSvg.svg`"
                            alt
                            class="responsive-img mr-2"
                            style="height: 13px;"
                          />
                          {{ formitem.questiontype }}
                        </v-btn>
                      </template>
                    </UploadDocument>
                    <div
                      v-if="formitem.value"
                      style="font-weight: 500;font-size: 12px;color: #BDBDBD;margin-top: 10px;"
                    >
                      (จำนวนไฟล์ที่อัปโหลดแล้ว : {{ formitem.value.length }} ไฟล์)
                    </div>
                    <div
                      v-else
                      style="font-weight: 500;font-size: 12px;color: #BDBDBD;margin-top: 10px;"
                    >
                      (จำนวนไฟล์ที่อัปโหลดแล้ว : 0 ไฟล์)
                    </div>
                  </div>
                </div>
              </div>
              <div v-for="(item, index) in formitem.value" :key="index" style="width: 100%">
                <div
                  class="text-truncate"
                  style="display:flex;flex-direction: row;gap:8px;align-items: center;"
                >
                  <span
                    style="font-size: 12px;font-weight:700; color:#26588B; cursor: pointer;"
                    @click="showItem(item)"
                  >
                    {{ showNameFormLink(item) }}
                  </span>
                  <span @click="deleteItem(index, k)">
                    <img
                      src="/static/img/delete.png"
                      alt
                      style="width:13px;height:15px;cursor: pointer;"
                    />
                  </span>
                </div>
              </div>
            </div>

            <div v-else-if="formitem.questiontype === 'บทความ'">
              <div style="font-weight: 600;font-size: 16px;color: #2C2C2C;">
                {{ formitem.name }}
              </div>
            </div>

            <div v-else-if="formitem.questiontype === 'ตัวเลข'">
              <div class="header-form">
                {{ formitem.name }}
                <span style="font-weight: 600;font-size: 16px;color: #BDBDBD;"
                  >(กรุณาใส่ตัวเลข {{ formitem.digitPosition }} หลัก)</span
                >
              </div>
              <input
                v-model="allform[k].value"
                class="input-form"
                :maxlength="formitem.digitPosition"
                type="text"
                @keypress="isNumber($event)"
              />
            </div>

            <div v-else-if="['ที่อยู่'].includes(formitem.questiontype)">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <div style="display:flex;flex-direction: column;margin-top:10px;gap:10px">
                <div style="display:flex;flex-direction: row;gap:15px;">
                  <input
                    v-model="allform[k].value.addressno"
                    class="input-form"
                    placeholder="(บ้านเลขที่)"
                  />
                </div>
                <div style="display:flex;flex-direction: row;gap:15px;">
                  <input
                    v-model="allform[k].value.zipcode"
                    class="input-form"
                    placeholder="(รหัสไปรษณีย์)"
                  />
                  <input
                    v-model="allform[k].value.province"
                    class="input-form"
                    placeholder="(จังหวัด)"
                  />
                </div>
                <div style="display:flex;flex-direction: row;gap:15px;">
                  <input
                    v-model="allform[k].value.district"
                    class="input-form"
                    placeholder="(แขวง/ตำบล)"
                  />
                  <input
                    v-model="allform[k].value.amphoe"
                    class="input-form"
                    placeholder="(เขต/อำเภอ)"
                  />
                </div>
              </div>
            </div>

            <div v-else-if="formitem.questiontype === 'ตัวอย่างไฟล์'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <v-btn
                :href="formitem.fileurl"
                target="_blank"
                class="rsu ma-0 customExamfileBtn"
                round
                depressed
              >
                <img :src="`/static/icon/fileSvg.svg`" alt class="responsive-img" />
                <Typography
                  h5
                  bold
                  color="color-mediumBlue"
                  class="customBtnText"
                  :label="formitem.fileurl"
                />
              </v-btn>
              <!-- <div
                class="text-truncate"
                style="display:flex;flex-direction: row;gap:8px;align-items: center;background: #E6F0FB;border-radius: 6px;padding: 4px 20px 4px 20px;height: 34px;width: fit-content;"
              >
                <span>
                  <img
                    src="/static/img/assets/menuIcons/previewFileIco.svg"
                    alt
                    style="width:13px;height:15px;"
                  />
                </span>
                <span
                  style="font-size: 12px;font-weight:700; color:#26588B; cursor: pointer;"
                  @click="showItem(item)"
                >
                  {{ formitem.fileurl }}
                </span>
              </div> -->
            </div>

            <div v-else-if="formitem.questiontype === 'วัน/เวลา'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <div style="display:flex;flex-direction: row;gap:14px">
                <div v-if="['all', 'date'].includes(formitem.Options)">
                  <div
                    style="width: 100%"
                    class="form-control"
                    :class="{ 'has-error': errors.has('End Date show') }"
                  >
                    <date-picker
                      :append-to-body="false"
                      :clearable="false"
                      :editable="false"
                      name="End Date show"
                      v-model="formitem.value"
                      valueType="date"
                      format="DD/MM/YYYY"
                      placeholder="เลือกวันที่เริ่ม"
                      confirm
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>
                </div>
                <div v-if="['all', 'time'].includes(formitem.Options)">
                  <div
                    style="width: 100%"
                    class="form-control"
                    :class="{ 'has-error': errors.has('End Date show') }"
                  >
                    <date-picker
                      :append-to-body="false"
                      :clearable="false"
                      :editable="false"
                      name="End Date show"
                      v-model="formitem.value2"
                      valueType="format"
                      type="time"
                      format="HH:mm"
                      placeholder="เลือกเวลา"
                      confirm
                    >
                    </date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="formitem.questiontype === 'แนบลิงก์'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <a
                :href="formitem.URL"
                target="_blank"
                style="font-size: 16px;color: #1890FF;text-decoration-line: underline;"
              >
                {{ formitem.URL }}</a
              >
            </div>

            <div v-else-if="formitem.questiontype === 'ช่องกรอกลิงก์'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <input
                v-model="allform[k].value"
                class="input-form"
                placeholder="http://www.example.com"
              />
            </div>

            <div v-else-if="formitem.questiontype === 'รูปภาพ'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <img :src="formitem.imgFile" style="width:100%;" />
            </div>

            <div v-else-if="formitem.questiontype === 'รายการผลิตภัณฑ์'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <div>
                <!-- <v-radio-group v-model="formitem.value" style="width:100%">
                  <v-radio
                    label="เลือกผลิตภัณฑ์ที่มีอยู่ในร้าน"
                    value="เลือกผลิตภัณฑ์ที่มีอยู่ในร้าน"
                    style="width: max-content;"
                  ></v-radio>

                  <div v-if="formitem.value" class="py-1">
                    <div v-if="formitem.value === 'เลือกผลิตภัณฑ์ที่มีอยู่ในร้าน'">
                      <v-select
                        v-model="formitem.value2"
                        :value="formitem.value2"
                        item-text="productname"
                        dense
                        outlined
                        return-object
                        append-icon="mdi-chevron-down"
                        :items="productMember"
                      >
                      </v-select>
                    </div>
                  </div>
                  <v-radio
                    style="width: max-content;"
                    label="เพิ่มผลิตภัณฑ์ใหม่"
                    value="เพิ่มผลิตภัณฑ์ใหม่"
                  ></v-radio>
                  <div v-if="formitem.value" class="py-1">
                    <div v-if="formitem.value === 'เพิ่มผลิตภัณฑ์ใหม่'">
                      <v-btn
                        small
                        depressed
                        class="mx-0"
                        color="primary"
                        style="color:rgba(255, 239, 1, 1);width:188px;height: 37px;font-weight: 700;font-size: 16px;"
                        :loading="loading"
                        @click="openModalAddpProductMember"
                      >
                        <img src="/static/img/assets/menuIcons/plusYellow.svg" alt />
                        เพิ่มผลิตภัณฑ์
                      </v-btn>
                    </div>
                  </div>
                </v-radio-group> -->

                <v-radio-group
                  v-bind:value="
                    (formitem.value = formitem.value || 'เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน')
                  "
                  v-on:change="formitem.value = $event"
                  class="mt-0 d-block"
                >
                  <v-radio
                    color="primary"
                    label="เลือกผลิตภัณฑ์ที่มีอยู่ในร้าน"
                    :value="'เลือกผลิตภัณฑ์ที่มีอยู่ในร้าน'"
                  ></v-radio>
                  <DropdownMenu
                    v-if="formitem.value == 'เลือกผลิตภัณฑ์ที่มีอยู่ในร้าน'"
                    v-model="formitem.value2"
                    :textLabel="'productname'"
                    :options="productMember"
                  >
                    <div style="position: relative" class="form-control">
                      <input
                        placeholder="เลือกผลิตภัณฑ์"
                        type="text"
                        class="option-input rsu"
                        style="cursor: pointer"
                        :value="formitem.value2.productname"
                      />
                    </div>
                  </DropdownMenu>
                  <v-radio
                    color="primary"
                    label="เพิ่มผลิตภัณฑ์ใหม่"
                    :value="'เพิ่มผลิตภัณฑ์ใหม่'"
                  ></v-radio>
                  <v-btn
                    v-if="formitem.value == 'เพิ่มผลิตภัณฑ์ใหม่'"
                    class="rsu customConfirmBtn ma-0 uploadBtn"
                    round
                    depressed
                    color="primary"
                    @click="openModalAddpProductMember"
                  >
                    <img
                      :src="`/static/icon/addYellowSvg.svg`"
                      alt
                      class="responsive-img mr-2"
                      style="height: 17px;"
                    />
                    เพิ่มผลิตภัณฑ์
                  </v-btn>
                  <div
                    v-if="formitem.value == 'เพิ่มผลิตภัณฑ์ใหม่'"
                    style="display: flex;flex-direction: row;align-items: center;margin-top: 8px; cursor: default"
                    @click="openModalEditProductMember(k)"
                  >
                    <div style="display: flex;flex-direction: row;align-items: center;color: #0c2f53;margin-right: 8px;">
                      <img
                        :src="`/static/img/ProductList.png`"
                        alt
                        class="responsive-img mr-2"
                        style="height: 17px;"
                      />
                      {{ formitem.value2.productname }}
                    </div>
                    <div  style="display: flex;flex-direction: row;align-items: center;">
                      <img
                        :src="`/static/img/TooltipEdit.png`"
                        alt
                        class="responsive-img mr-2"
                        style="height: 17px;"
                      />
                    </div>
                  </div>
                    <v-dialog v-model="modalAddpProductMember" width="647px">
                      
                      <div v-if="modalAddpProductMember" style="position: relative;">
                        <div style="position: absolute; right: 0px; top: 0px">
                          <v-btn @click="closeModalAddpProductMember" icon>
                            <v-icon color="#0C2F53" large>close</v-icon>
                          </v-btn>
                        </div>
                        <div style="padding: 40px 40px;">
                          <div
                            style="background-color: #fff; color: #0C2F53; padding-bottom: 30px; font-size: 24px;font-weight: 700;"
                          >
                            ข้อมูลแบบฟอร์ม
                          </div>
                          <div style="display:flex;flex-direction: column;gap:20px">
                            <div
                              style="display:flex;flex-direction: column;justify-content: center;width:100%;"
                            >
                              <div
                                :ref="'answer_' + (intent_index - 1) + '_' + intent_index"
                                class="message"
                                style="float:left; position:relative; border-radius: 12px;height: 246px;width: 100%; overflow-wrap: break-word; min-height: 22px; min-width: 14px; line-height: 15.20px; overflow: hidden;margin-top: 40px; "
                              >
                                <uploadfile
                                  ref="answer"
                                  v-model="addProductData.img"
                                  :height="246"
                                  data-vv-as="Image"
                                  :data-vv-name="
                                    'answer_' + (intent_index - 1) + '_image_' + intent_index
                                  "
                                  v-validate
                                ></uploadfile>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ชื่อสินค้า
                              </div>
                              <input
                                v-model="addProductData.productname"
                                class="input-form-modal"
                              />
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                Tag
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.tagid"
                                  item-text="tagname"
                                  item-value="tagid"
                                  dense
                                  outlined
                                  :items="addProducttagId"
                                  append-icon="mdi-chevron-down"
                                  @change="changCategory"
                                >
                                </v-select>
                              </div>
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                ประเภทสินค้า
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.producttype"
                                  item-text="label"
                                  dense
                                  outlined
                                  :items="addProducttype"
                                  append-icon="mdi-chevron-down"
                                >
                                </v-select>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                คุณสมบัติการทำงาน
                              </div>
                              <textarea
                                v-model="addProductData.description"
                                style="width:100%;height:100px; padding:14px;border: 1px solid #0C2F53;border-radius: 10px;"
                                class="text-area-focus"
                                name="ข้อความ"
                                maxlength="2000"
                              >
                              </textarea>
                            </div>
                            <div
                              v-if="addProductData.producttype === 'hardware'"
                              style="display:flex;flex-direction: column;gap:20px"
                            >
                              <div class="flex-input">
                                <div class="header-form">
                                  รุ่นอุปกรณ์
                                </div>
                                <input
                                  v-model="addProductData.deviceversion"
                                  class="input-form-modal"
                                />
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  อื่นๆ
                                </div>
                                <input
                                  v-model="addProductData.otherdetail"
                                  class="input-form-modal"
                                />
                              </div>
                              <div style="display:flex;flex-direction:row;gap:20px;">
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคา (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.price"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                    style="width:94%"
                                  />
                                </div>
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคาหลังหักส่วนลด (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.discountprice"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                    style="width:94%"
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="addProductData.producttype === 'software'"
                              style="display:flex;flex-direction: column;gap:20px"
                            >
                              <div class="flex-input">
                                <div class="header-form">
                                  ช่องทางการใช้งาน
                                </div>
                                <input
                                  v-model="addProductData.workchannel"
                                  class="input-form-modal"
                                />
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  การให้บริการ
                                </div>
                                <div class="form-detailmember">
                                  <v-select
                                    class="button-select"
                                    v-model="addProductData.service"
                                    item-text="label"
                                    item-value="value"
                                    dense
                                    outlined
                                    :items="addProdustservice"
                                    append-icon="mdi-chevron-down"
                                  >
                                  </v-select>
                                </div>
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  อื่นๆ
                                </div>
                                <input
                                  v-model="addProductData.otherdetail"
                                  class="input-form-modal"
                                />
                              </div>
                              <div style="display:flex;flex-direction:row;gap:20px;">
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคา (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.price"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคาหลังหักส่วนลด (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.discountprice"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="addProductData.producttype === 'service'"
                              style="display:flex;flex-direction: column;gap:20px"
                            >
                              <div class="flex-input">
                                <div class="header-form">
                                  ช่องทางการใช้งาน
                                </div>
                                <input
                                  v-model="addProductData.workchannel"
                                  class="input-form-modal"
                                />
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  อื่นๆ
                                </div>
                                <input
                                  v-model="addProductData.otherdetail"
                                  class="input-form-modal"
                                />
                              </div>
                              <div style="display:flex;flex-direction:row;gap:20px;">
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคา (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.price"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคาหลังหักส่วนลด (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.discountprice"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                แคมเปญ
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.campaignid"
                                  item-text="campaignname"
                                  item-value="id"
                                  dense
                                  outlined
                                  :items="addProductcampaign"
                                  append-icon="mdi-chevron-down"
                                >
                                </v-select>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ประเภทธุรกิจ 
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.typename"
                                  item-text="typename"
                                  item-value="typename"
                                  dense
                                  outlined
                                  :items="addProducttypename"
                                  append-icon="mdi-chevron-down"
                                  @change="changType"
                                >
                                </v-select>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                หมวดหมู่ 
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.categoryname"
                                  item-text="categoryname"
                                  item-value="categoryname"
                                  dense
                                  outlined
                                  :items="addProductcategory"
                                  append-icon="mdi-chevron-down"
                                  @change="changCategory"
                                >
                                </v-select>
                              </div>
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                Hashtag
                              </div>
                              <div>
                                <Multiselect
                                  class="multipleSelect"
                                  :options="addProducttag.map(item => item.tag)"
                                  v-model="allTags"
                                  :multiple="true"
                                  :searchable="true"
                                  :taggable="true"
                                  @input="addTag($event)"
                                  placeholder="Hashtag"
                                >
                                  <span slot="caret" slot-scope="{ toggle }" class="arrow">
                                    <v-icon class="darkBlue" aria-hidden="false" size="24px">
                                      mdi-chevron-down
                                    </v-icon>
                                  </span>
                                </Multiselect>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ประเภทลิขสิทธิ์
                              </div>
                              <input
                                v-model="addProductData.copyrighttype"
                                class="input-form-modal"
                              />
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ตัวแทนขาย
                              </div>
                              <input
                                v-model="addProductData.salesrepresentatives"
                                class="input-form-modal"
                              />
                            </div>
                            <div class="btn-footer">
                              <v-btn class="btn-cancel" @click="closeModalAddpProductMember">
                                ยกเลิก
                              </v-btn>
                              <v-btn class="btn-summit" @click="summitProduct(k)">
                                ยืนยัน
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-dialog>
                    <v-dialog v-model="modalEditProductMember" width="647px">
                      <div v-if="modalEditProductMember" style="position: relative;">
                        <div style="position: absolute; right: 0px; top: 0px">
                          <v-btn @click="closeModalEditProductMember" icon>
                            <v-icon color="#0C2F53" large>close</v-icon>
                          </v-btn>
                        </div>
                        <div style="padding: 40px 40px;">
                          <div
                            style="background-color: #fff; color: #0C2F53; padding-bottom: 30px; font-size: 24px;font-weight: 700;"
                          >
                            แก้ไขข้อมูลแบบฟอร์ม
                          </div>
                          <div style="display:flex;flex-direction: column;gap:20px">
                            <div
                              style="display:flex;flex-direction: column;justify-content: center;width:100%;"
                            >
                              <div
                                :ref="'answer_' + (intent_index - 1) + '_' + intent_index"
                                class="message"
                                style="float:left; position:relative; border-radius: 12px;height: 246px;width: 100%; overflow-wrap: break-word; min-height: 22px; min-width: 14px; line-height: 15.20px; overflow: hidden;margin-top: 40px; "
                              >
                                <uploadfile
                                  ref="answer"
                                  v-model="addProductData.img"
                                  :height="246"
                                  data-vv-as="Image"
                                  :data-vv-name="
                                    'answer_' + (intent_index - 1) + '_image_' + intent_index
                                  "
                                  v-validate
                                ></uploadfile>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ชื่อสินค้า
                              </div>
                              <input
                                v-model="addProductData.productname"
                                class="input-form-modal"
                              />
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                Tag
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.tagid"
                                  item-text="tagname"
                                  item-value="tagid"
                                  dense
                                  outlined
                                  :items="addProducttagId"
                                  append-icon="mdi-chevron-down"
                                  @change="changCategory"
                                >
                                </v-select>
                              </div>
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                ประเภทสินค้า
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.producttype"
                                  item-text="label"
                                  dense
                                  outlined
                                  :items="addProducttype"
                                  append-icon="mdi-chevron-down"
                                >
                                </v-select>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                คุณสมบัติการทำงาน
                              </div>
                              <textarea
                                v-model="addProductData.description"
                                style="width:100%;height:100px; padding:14px;border: 1px solid #0C2F53;border-radius: 10px;"
                                class="text-area-focus"
                                name="ข้อความ"
                                maxlength="2000"
                              >
                              </textarea>
                            </div>
                            <div
                              v-if="addProductData.producttype === 'hardware'"
                              style="display:flex;flex-direction: column;gap:20px"
                            >
                              <div class="flex-input">
                                <div class="header-form">
                                  รุ่นอุปกรณ์
                                </div>
                                <input
                                  v-model="addProductData.deviceversion"
                                  class="input-form-modal"
                                />
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  อื่นๆ
                                </div>
                                <input
                                  v-model="addProductData.otherdetail"
                                  class="input-form-modal"
                                />
                              </div>
                              <div style="display:flex;flex-direction:row;gap:20px;">
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคา (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.price"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                    style="width:94%"
                                  />
                                </div>
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคาหลังหักส่วนลด (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.discountprice"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                    style="width:94%"
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="addProductData.producttype === 'software'"
                              style="display:flex;flex-direction: column;gap:20px"
                            >
                              <div class="flex-input">
                                <div class="header-form">
                                  ช่องทางการใช้งาน
                                </div>
                                <input
                                  v-model="addProductData.workchannel"
                                  class="input-form-modal"
                                />
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  การให้บริการ
                                </div>
                                <div class="form-detailmember">
                                  <v-select
                                    class="button-select"
                                    v-model="addProductData.service"
                                    item-text="label"
                                    item-value="value"
                                    dense
                                    outlined
                                    :items="addProdustservice"
                                    append-icon="mdi-chevron-down"
                                  >
                                  </v-select>
                                </div>
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  อื่นๆ
                                </div>
                                <input
                                  v-model="addProductData.otherdetail"
                                  class="input-form-modal"
                                />
                              </div>
                              <div style="display:flex;flex-direction:row;gap:20px;">
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคา (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.price"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคาหลังหักส่วนลด (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.discountprice"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="addProductData.producttype === 'service'"
                              style="display:flex;flex-direction: column;gap:20px"
                            >
                              <div class="flex-input">
                                <div class="header-form">
                                  ช่องทางการใช้งาน
                                </div>
                                <input
                                  v-model="addProductData.workchannel"
                                  class="input-form-modal"
                                />
                              </div>
                              <div class="flex-input">
                                <div class="header-form">
                                  อื่นๆ
                                </div>
                                <input
                                  v-model="addProductData.otherdetail"
                                  class="input-form-modal"
                                />
                              </div>
                              <div style="display:flex;flex-direction:row;gap:20px;">
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคา (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.price"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                                <div class="flex-input">
                                  <div class="header-form" style="width:100%;">
                                    ราคาหลังหักส่วนลด (บาท)
                                  </div>
                                  <input
                                    v-model="addProductData.discountprice"
                                    class="input-form-modal"
                                    @keypress="isNumber($event)"
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                แคมเปญ 
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.campaignid"
                                  item-text="campaignname"
                                  item-value="id"
                                  dense
                                  outlined
                                  :items="addProductcampaign"
                                  append-icon="mdi-chevron-down"
                                >
                                </v-select>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ประเภทธุรกิจ 
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.typename"
                                  item-text="typename"
                                  item-value="typename"
                                  dense
                                  outlined
                                  :items="addProducttypename"
                                  append-icon="mdi-chevron-down"
                                  @change="changEditType(k)"
                                >
                                </v-select>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                หมวดหมู่ 
                              </div>
                              <div class="form-detailmember">
                                <v-select
                                  class="button-select"
                                  v-model="addProductData.categoryname"
                                  item-text="categoryname"
                                  item-value="categoryname"
                                  dense
                                  outlined
                                  :items="addProductcategory"
                                  append-icon="mdi-chevron-down"
                                  @change="changCategory"
                                >
                                </v-select>
                              </div>
                            </div>

                            <div class="flex-input">
                              <div class="header-form">
                                Hashtag
                              </div>
                              <div>
                                <Multiselect
                                  class="multipleSelect"
                                  :options="addProducttag.map(item => item.tag)"
                                  v-model="addProductData.tags"
                                  :multiple="true"
                                  :searchable="true"
                                  :taggable="true"
                                  placeholder="Hashtag"
                                >
                                  <span slot="caret" slot-scope="{ toggle }" class="arrow">
                                    <v-icon class="darkBlue" aria-hidden="false" size="24px">
                                      mdi-chevron-down
                                    </v-icon>
                                  </span>
                                </Multiselect>
                              </div>
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ประเภทลิขสิทธิ์
                              </div>
                              <input
                                v-model="addProductData.copyrighttype"
                                class="input-form-modal"
                              />
                            </div>
                            <div class="flex-input">
                              <div class="header-form">
                                ตัวแทนขาย
                              </div>
                              <input
                                v-model="addProductData.salesrepresentatives"
                                class="input-form-modal"
                              />
                            </div>
                            <div class="btn-footer">
                              <v-btn class="btn-cancel" @click="closeModalEditProductMember">
                                ยกเลิก
                              </v-btn>
                              <v-btn class="btn-summit" @click="summitEditProduct(k)">
                                ยืนยัน
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-dialog>
                  
                </v-radio-group>
                <a
                  :href="urlTecthuntProduct + formitem.value2.productid"
                  target="_blank"
                  style="font-size: 16px;color:#26588B;font-weight:700;"
                  >ดูข้อมูลผลิตภัณฑ์</a
                >
              </div>
            </div>

            <div v-else-if="formitem.questiontype === 'ตาราง'">
              <div class="header-form">
                {{ formitem.name }}
              </div>
              <v-flex xs12 v-if="formitem.formTable.data.length">
                <template>
                  <v-layout row wrap class="ma-0">
                    <div class="generate-table-container">
                      <table class="form-generate-table">
                        <thead>
                          <tr>
                            <th
                              v-for="(header, headerIndex) in formitem.formTable.data[0]"
                              :key="headerIndex"
                              :class="
                                !formitem.formTable.viewColumn && headerIndex === 0 ? 'd-none' : ''
                              "
                            >
                              <v-text-field
                                v-if="headerIndex === 0"
                                solo
                                v-model="formitem.formTable.data[0][headerIndex]"
                                class="editTextTable firstItem rsu"
                                single-line
                                readonly
                              >
                              </v-text-field>
                              <v-text-field
                                v-if="headerIndex != 0"
                                solo
                                v-model="formitem.formTable.data[0][headerIndex]"
                                class="editTextTable rsu"
                                single-line
                                readonly
                              >
                              </v-text-field>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(row, rowIndex) in formitem.formTable.data.slice(1)"
                            :key="rowIndex"
                          >
                            <td
                              v-for="(column, columnIndex) in row"
                              :key="columnIndex"
                              :class="
                                !formitem.formTable.viewColumn && columnIndex === 0 ? 'd-none' : ''
                              "
                            >
                              <v-text-field
                                v-if="columnIndex === 0"
                                solo
                                v-model="formitem.formTable.data[rowIndex + 1][0]"
                                class="editTextTable rsu"
                                single-line
                                readonly
                              >
                              </v-text-field>
                              <v-text-field
                                v-else
                                solo
                                v-model="formitem.formTable.data[rowIndex + 1][columnIndex]"
                                class="editTextTable rsu"
                                single-line
                              >
                              </v-text-field>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-layout>
                </template>
              </v-flex>
            </div>
          </div>

          <div>
            <v-layout row wrap>
              <v-flex xs6>
                <div class="text-xs-right pt-3">
                  <v-btn
                    v-if="currentPage !== 0"
                    @click="currentPage--"
                    style="width:142px;height:38px;background: #FFFFFF;border: 1px solid #0C2F53;border-radius: 6px;font-weight: 700;font-size: 16px;color: #0C2F53;"
                    depressed
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                    ย้อนกลับ
                  </v-btn>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="text-xs-left pt-3">
                  <v-btn
                    v-if="currentPage + 1 !== totalPage[this.index_form]"
                    @click="currentPage++"
                    style="width:142px;height:38px;background: #FFFFFF;border: 1px solid #0C2F53;border-radius: 6px;font-weight: 700;font-size: 16px;color: #0C2F53;"
                    depressed
                  >
                    ถัดไป
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </div>

          <div v-if="index_form === 0">
            <div
              class="pt-2"
              v-if="
                totalPage[this.index_form] == 1 || totalPage[this.index_form] - 1 == currentPage
              "
              style="display:flex;flex-direction: row;justify-content: center;gap:12px;"
            >
              <div>
                <v-btn class="rsu" block style="border-radius: 7px" outline color="primary">
                  {{ formShow.reject ? formShow.reject : 'ยกเลิก' }}
                </v-btn>
              </div>
              <div @click="saveApplicant(currentdata, currentFormData)">
                <v-btn
                  class="rsu"
                  block
                  style="border-radius: 7px;color: #FFEF01;"
                  depressed
                  color="primary"
                >
                  {{ formShow.button ? formShow.button : 'บันทึก' }}
                </v-btn>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="pt-2"
              v-if="
                totalPage[this.index_form] == 1 || totalPage[this.index_form] - 1 == currentPage
              "
              style="display:flex;flex-direction: row;justify-content: center;gap:12px;"
            >
              <div @click="toggleModalRejectApplication">
                <v-btn
                  class="rsu"
                  block
                  style="background: #AA2F2F;border-radius: 6px;color: #FFFFFF;"
                  depressed
                >
                  ไม่อนุมัติ
                </v-btn>
              </div>
              <div @click="depaConfirmapplication">
                <v-btn
                  class="rsu"
                  block
                  style="background: #69B345;border-radius: 6px;color: #FFFFFF;"
                  depressed
                >
                  อนุมัติ
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-dialog v-model="modalRejectApplication" width="647px">
        <div v-if="modalRejectApplication" style="position: relative;">
          <div style="position: absolute; right: 0px; top: 0px">
            <v-btn @click="toggleModalRejectApplication" icon>
              <v-icon color="#0C2F53" large>close</v-icon>
            </v-btn>
          </div>
          <div style="padding: 40px 20px;">
            <div
              style="background-color: #fff; color: #0C2F53; padding-bottom: 30px; font-size: 24px;font-weight: 700;"
            >
              เหตุผลที่ไม่อนุมัติ 
            </div>
            <textarea
              v-model="rejectMessageApplication"
              style="width:100%;height:100px; padding:14px;border: 1px solid #0C2F53;border-radius: 10px;"
              class="text-area-focus"
              name="ข้อความ"
              maxlength="2000"
            >
            </textarea>
            <div
              class="pt-2"
              style="display:flex;flex-direction: row;justify-content: center;gap:12px;"
            >
              <div @click="toggleModalRejectApplication">
                <v-btn class="rsu" block style="border-radius: 7px" outline color="primary">
                  ยกเลิก
                </v-btn>
              </div>
              <div @click="depaRejectapplication">
                <v-btn
                  class="rsu"
                  block
                  style="border-radius: 7px;color: #FFEF01;"
                  depressed
                  color="primary"
                >
                  บันทึก
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>

    <div class="footer-formDetailMember">
      <div>
        <div v-if="this.applicantstatus == 1">
          <v-btn
            class="rsu customInfoBtn "
            depressed
            color="primary"
            style="width:140px;height:40px"
            @click="toggleModalDepasendReport"
          >
            ขอเอกสารเพิ่มเติม
          </v-btn>
        </div>
        <div v-else>
          <v-btn
            class="rsu customInfoBtn customDisableBtn"
            depressed
            color="primary"
            style="width:140px;height:40px"
          >
            ขอเอกสารเพิ่มเติม
          </v-btn>
        </div>
        <v-dialog v-model="modalDepasendReport" width="647px">
          <div v-if="modalDepasendReport" style="position: relative;">
            <div style="position: absolute; right: 0px; top: 0px">
              <v-btn @click="toggleModalDepasendReport" icon>
                <v-icon color="#0C2F53" large>close</v-icon>
              </v-btn>
            </div>
            <div style="padding: 40px 20px;">
              <div
                style="background-color: #fff; color: #0C2F53; padding-bottom: 30px; font-size: 24px;font-weight: 700;"
              >
                ขอเอกสารเพิ่มเติม
              </div>

              <textarea
                v-model="sendReportData.text"
                style="width:100%;height:100px; padding:14px;border: 1px solid #0C2F53;border-radius: 10px;"
                class="text-area-focus"
                name="ข้อความ"
                maxlength="2000"
                placeholder="กรุณากรอกความคิดเห็น"
              >
              </textarea>
              <v-checkbox
                :value="true"
                :label="`แนบแบบฟอร์มไปด้วย`"
                v-model="sendReportData.sendForm"
                class="ma-0 mb-2"
                outlined
                hide-details
                dense
              >
              </v-checkbox>
              <div
                class="pt-2"
                style="display:flex;flex-direction: row;justify-content: center;gap:12px;"
              >
                <div @click="toggleModalDepasendReport">
                  <v-btn class="rsu" block style="border-radius: 7px" outline color="primary">
                    ยกเลิก
                  </v-btn>
                </div>
                <div @click="summitDepasendReport">
                  <v-btn
                    class="rsu"
                    block
                    style="border-radius: 7px;color: #FFEF01;"
                    depressed
                    color="primary"
                  >
                    บันทึก
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <div>
        <div v-if="this.applicantstatus <= 2">
          <v-btn
            class="rsu customInfoBtn "
            depressed
            color="primary"
            style="width:140px;height:40px"
            @click="summitConsider"
          >
            ส่งตรวจสอบ
          </v-btn>
        </div>
        <div v-else>
          <v-btn
            class="rsu customInfoBtn customDisableBtn"
            depressed
            color="primary1"
            style="width:140px;height:40px"
          >
            ส่งตรวจสอบ
          </v-btn>
        </div>
      </div>
      <div>
        <div v-if="this.applicantstatus <= 3">
          <v-btn
            class="rsu customRejectBtn "
            depressed
            color="primary"
            style="width:140px;height:40px"
            @click="toggleModalAllApplication"
          >
            ไม่อนุมัติ
          </v-btn>
          <v-dialog v-model="modalAllApplication" width="647px">
            <div v-if="modalAllApplication" style="position: relative;">
              <div style="position: absolute; right: 0px; top: 0px">
                <v-btn @click="toggleModalAllApplication" icon>
                  <v-icon color="#0C2F53" large>close</v-icon>
                </v-btn>
              </div>
              <div style="padding: 40px 20px;">
                <div
                  style="background-color: #fff; color: #0C2F53; padding-bottom: 30px; font-size: 24px;font-weight: 700;"
                >
                  เหตุผลที่ไม่อนุมัติ
                </div>
                <textarea
                  v-model="rejectMessageAllApplication"
                  style="width:100%;height:100px; padding:14px;border: 1px solid #0C2F53;border-radius: 10px;"
                  class="text-area-focus"
                  name="ข้อความ"
                  maxlength="2000"
                >
                </textarea>
                <div
                  class="pt-2"
                  style="display:flex;flex-direction: row;justify-content: center;gap:12px;"
                >
                  <div @click="toggleModalAllApplication">
                    <v-btn class="rsu" block style="border-radius: 7px" outline color="primary">
                      ยกเลิก
                    </v-btn>
                  </div>
                  <div @click="rejectApplication">
                    <v-btn
                      class="rsu"
                      block
                      style="border-radius: 7px;color: #FFEF01;"
                      depressed
                      color="primary"
                    >
                      บันทึก
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
        </div>
        <div v-else>
          <v-btn
            class="rsu customRejectBtn customDisableBtn"
            readonly
            depressed
            color="primary"
            style="width:140px;height:40px"
          >
            ไม่อนุมัติ
          </v-btn>
        </div>
      </div>
      <div>
        <div v-if="this.applicantstatus <= 3">
          <v-btn
            class="rsu customApproveBtn"
            depressed
            color="primary"
            style="width:140px;height:40px"
            @click="confirmApplication"
          >
            อนุมัติ
          </v-btn>
        </div>
        <div v-else>
          <v-btn
            class="rsu customApproveBtn customDisableBtn"
            readonly
            depressed
            color="primary"
            style="width:140px;height:40px"
          >
            อนุมัติ
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Typography from '@/components/elements/Typography.vue'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import uploadfile from '@/components/elements/uploadfile.vue'
import FormDetailSubquestion from './FormDetailSubquestion.vue'
import uploadalltype from '@/components/elements/uploadalltype'
import UploadDocument from '@/components/elements/UploadDocument.vue'

import api from '@/api'
import config from '@/config'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import moment from 'moment'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  props: [
    'formdataall',
    'showPreview',
    'currentdata',
    'projects',
    'uploadalltype',
    'currentFormData'
  ],

  components: {
    Typography,
    AutoresizeTextarea,
    DropdownMenu,
    uploadfile,
    uploadalltype,
    FormDetailSubquestion,
    UploadDocument,
    DatePicker,
    DatepickerCustomDialog,
    CustomTimepicker,
    Multiselect
  },
  data() {
    return {
      urlTecthuntProduct: '',
      sendForm: false,
      resendtext: '',
      popresend: false,
      reporttext: '',
      popreport: false,
      nativeSelectedItems: [],
      menu: false,
      resendloading: false,
      data: [],
      optionsStatus: ['กล่องข้อความ', 'หลายตัวเลือก', 'เลื่อนลง', 'ช่องทำเครื่องหมาย'],
      input: {
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [''],
        fields2: ['']
      },
      currentPage: 0,
      totalPage: [],
      currentStep: 0,
      // nextStepData: null,
      // nextStepForm: null,
      // popModelNextStep: false
      applicantstatus: '',
      stepResult: [],
      projectdata: [],
      typedata: [],
      index_form: 0,
      formShow: [],
      nameForm: '',
      productMember: [],
      modalEditProductMember: false,
      modalAddpProductMember: false,
      addProductData: {
        productid: 0,
        img: '',
        productname: '',
        producttype: 'hardware',
        description:'',
        deviceversion: '',
        workchannel: '',
        service: '',
        otherdetail: '',
        price: '',
        discountprice: '',
        campaignid: '',
        salesrepresentatives: '',
        categoryname: '',
        categoryid: 0,
        typename: '',
        typeid: '',
        tags: '',
        tagid: 0,
        copyrighttype: ''
      },
      addProducttype: ['hardware', 'software', 'service'],
      addProdustservice: [{ label: 'ซื้อขาด', value: 'buy' }, { label: 'ซื้อเช่า', value: 'rent' }],
      addProductcampaign: [],
      addProducttypename: [],
      addProductcategory: [],
      addProducttag: [],
      addProducttagId: 0,
      allTags: [],
      //
      modalRejectApplication: false,
      rejectMessageApplication: '',
      modalAllApplication: false,
      rejectMessageAllApplication: '',
      modalDepasendReport: false,
      sendReportData: {
        text: '',
        sendForm: false
      }
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    }),
    currentProject() {
      let vm = this
      return this.projects.find(p => {
        return p.id == vm.currentdata.projectid
      })
    },
    currentProjectData() {
      let output = null
      try {
        output = JSON.parse(this.currentProject.projectdata)
      } catch (error) {
        console.error('parse JSON ERROR')
        output = null
      }
      return output
    },

    currentProjectStepList() {
      if (this.currentProjectData) {
        return this.currentProjectData.map(p => {
          return p.stepid
        })
      } else {
        return []
      }
    },
    currentStepid() {
      let output = []
      try {
        let current_stepid = Object.keys(this.formdataall)[
          parseInt(Object.keys(this.formdataall).length) - 1
        ]
        output = current_stepid
      } catch (error) {
        console.error('convert json', error)
        return null
      }
      return output
    },
    nextStepid() {
      let output = []
      let current_stepid = this.currentStepid
      let project = this.currentProjectData
      output = project[this.currentProjectStepList.indexOf(current_stepid) + 1]
        ? project[this.currentProjectStepList.indexOf(current_stepid) + 1].stepid
        : null
      return output
    },
    nextStepLink() {
      if (this.nextStepid) {
        let tsmp = new Date()
        return `${
          config.liff
        }?view=CustomForm&apptype=line&pageid=DEPA&tsmp=${tsmp.getTime()}&projectid=${
          this.currentProject.id
        }&mode=edit&first=false&applicantid=${this.currentdata.applicantid}&current_stepid=${
          this.nextStepid
        }&previous_stepid=${this.currentStepid}&previous_memberid=${this.currentdata.memberid}`
      } else {
        return null
      }
    },
    selectedValue() {
      if (this.value) {
        return this.formitem.fields.find(el => el.label == this.value)
      }
    },
    isReadonly() {
      return true
    },
    allform() {
      let result
      if (this.index_form == 0) {
        // result = this.data[0].formitems
        result = _.get(this.data, `0.formitems`, [])
      } else {
        result = this.formShow.formitems
      }

      if (result.some(el => el.questiontype == 'หน้าถัดไป')) {
        let data = []
        let count = 0
        // eslint-disable-next-line no-continue
        result.map((el, index) => {
          if (el.questiontype == 'ที่อยู่') {
            try {
              if (typeof el.value == 'string') {
                if (el.value == '') {
                  el.value = {
                    addressno: '',
                    province: '',
                    amphoe: '',
                    district: '',
                    zipcode: ''
                  }
                } else {
                  el.value = JSON.parse(el.value)
                }
              } else {
                el.value = el.value
              }
              // el.value = JSON.parse(el.value)
              //el.value = el.value
            } catch (error) {
              el.value = el.value
              console.error(error)
            }
          }
          if (el.questiontype == 'วัน/เวลา') {
            if (el.value !== '') {
              el.value = moment(el.value).toDate()
            }
          }
          if (el.questiontype == 'หน้าถัดไป') {
            count += 1
          } else {
            // eslint-disable-next-line no-continue4
            if (data[count]) {
              data[count].push(el)
            } else {
              data.push([el])
            }
          }
        })
        this.totalPage[this.index_form] = data.length
        return data[this.currentPage]
      } else {
        result.forEach(el => {
          if (el.questiontype == 'ที่อยู่') {
            try {
              if (typeof el.value == 'string') {
                if (el.value == '') {
                  el.value = {
                    addressno: '',
                    province: '',
                    amphoe: '',
                    district: '',
                    zipcode: ''
                  }
                } else {
                  el.value = JSON.parse(el.value)
                }
              } else {
                el.value = el.value
              }
            } catch (error) {
              el.value = el.value
              console.error(error)
            }
          }
          if (el.questiontype == 'วัน/เวลา') {
            if (el.value !== '') {
              el.value = moment(el.value).toDate()
            }
          }
        })
        this.totalPage[this.index_form] = 1

        return result
      }
    }
  },
  mounted() {
    for (const [key, value] of Object.entries(this.formdataall)) {
      this.data.push({
        ...value[0],
        stepid: key
      })
    }
    this.getDepaData()
    this.getProductMember()
    this.urlTecthuntProduct = `${config.techhuntUrl}product?id=`
  },
  methods: {
    _get: _.get,
    async saveApplicant(data, form) {
      const formData = {
        projectname: this.data[0].projectname,
        memberid: this.data[0].memberid,
        formname: this.data[0].formname,
        profiledata: this.data[0].profiledata,
        formitems: this.data[0].formitems,
        button: this.data[0].button,
        reject: this.data[0].reject
      }
      let body = {
        applicantid: data.applicantid,
        memberid: data.memberid,
        stepid: Object.keys(form)[0] ? Object.keys(form)[0] : null,
        formdata: formData
      }
      let resStatus = await api.updateApplicantDetail(body)
      if (resStatus) {
        this.$swal.fire({
          title: 'บันทึกข้อมูลสำเร็จ',
          type: 'success'
        })
      } else {
        await this.$swal.fire({
          type: 'error',
          title: 'บันทึกข้อมูลไม่สำเร็จ'
        })
      }
    },
    async changPage(prop) {
      if (prop == '+') {
        this.currentPage = this.currentPage + 1
      } else if (prop == '-') {
        this.currentPage = this.currentPage - 1
      }
      //await this.$nextTick();
      this.$forceUpdate()
    },
    showNameFormLink(link) {
      try {
        let tempLink = decodeURI(link)
        tempLink = tempLink.split('/')
        tempLink = tempLink[tempLink.length - 1]
        tempLink = tempLink.split('')
        tempLink.shift()
        tempLink = tempLink.join('')
        return tempLink
      } catch (error) {
        return link
      }
    },
    showItem(item) {
      window.open(item, '_blank').focus()
    },
    deleteItem: function(index, k) {
      var result = this.allform
      var data_file = result[k].value
      data_file.splice(index, 1)
    },
    updateInput(notify, e) {
      this.$forceUpdate()
    },
    async checkApplicant(data) {
      var result = await this.$swal.fire({
        title: this.$t('ยืนยันการตรวจสอบใช่หรือไม่', {
          name: ''
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let resStatus = await api.updateApplicantCheck(this.currentdata.applicantid, {
          check: data
        })
        if (resStatus) {
          this.$swal.fire({
            title: 'บันทึกข้อมูลสำเร็จ',
            type: 'success'
          })
          this.$emit('reload')
          this.$emit('close')
        } else {
          await this.$swal.fire({
            type: 'error',
            title: 'บันทึกข้อมูลไม่สำเร็จ'
          })
        }
      }
    },
    openNextStep() {
      window.open(this.nextStepLink)
    },
    depadateFormat(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    },
    depadateFormat2(date) {
      if (date) {
        return moment(date).toDate()
      } else return ''
    },
    subQuestionData(item, value) {
      if (item.find(el => el.label == value)) {
        return item.find(el => el.label == value).subquestion
      } else return null
    },
    popresendForm() {
      this.resendtext = ''
      this.popresend = true
    },
    popreportForm() {
      this.reporttext = ''
      this.popreport = true
    },
    closepopresendForm() {
      this.resendtext = ''
      this.popresend = false
    },
    closepopreportForm() {
      this.reporttext = ''
      this.popreport = false
    },
    reportForm() {
      let vm = this
      var data = {
        applicantid: this.currentdata.applicantid,
        memberid: this.currentdata.memberid,
        text: this.reporttext,
        sendForm: this.sendForm,
        projectid: this.currentProject && this.currentProject.id ? this.currentProject.id : null,
        applicantid:
          this.currentdata && this.currentdata.applicantid ? this.currentdata.applicantid : null
      }
      this.resendloading = true
      api.depasendreport(data, async (err, response) => {
        this.resendloading = false
        await this.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })
        vm.$emit('reload')
        this.reporttext = ''
        this.popreport = false
      })
    },
    // resendForm() {
    //   var data = {
    //     applicantid: this.currentdata.applicantid,
    //     stepid: this.data[this.currentStep].stepid,
    //     text: this.resendtext
    //   }
    //   this.resendloading = true
    //   api.deparesendnotifyformbystepid(data, async (err, response) => {
    //     this.resendloading = false
    //     await this.$swal.fire({
    //       text: 'สำเร็จ',
    //       type: 'success'
    //     })
    //     this.resendtext = ''
    //     this.popresend = false
    //   })
    // },
    filteredName(item) {
      if (item.name) {
        return item.name
      } else if (item.coordinator_name) {
        return item.coordinator_name
      } else if (item.institute_name) {
        return item.institute_name
      }
    },
    changeStep(op) {
      this.currentPage[this.index_form] = 0
      if (op == '+') {
        this.currentStep++
      } else if (op == '-') {
        this.currentStep--
      }
    },
    showItem(item) {
      window.open(item, '_blank').focus()
    },

    onChange(label, k) {
      //this.nativeSelectedItems = this.nativeSelectedItems
      if (this.allform[k].value === '') {
        this.allform[k].value = [label]
      } else {
        this.allform[k].value.map(item => {
          if (item === label) {
            return
          } else if (item === allform[k].value) {
          }
        })
      }
      this.allform[k].value = [...this.allform[k].value, label]
    },
    // deleteItem(item) {
    //   console.log(item)
    // }
    isNumber: function(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    async getDepaData() {
      await this.getdepaprojectbyid()
      await this.getdepaprojectformbyid(this.typedata[this.index_form].customform)
      await this.getDepaapplicantStatus()
      this.$forceUpdate()
    },
    async changIndexForm(key) {
      if (this.stepResult[key].action === 'Approve' && key !== 0) {
        return
      } else if (this.stepResult[key].action === 'Reject' && key !== 0) {
        return
      } else {
        this.currentPage = 0
        this.index_form = key
        if (key === 0) {
        } else if (typeof this.typedata[this.index_form].customform === 'string') {
          console.log(
            'this.typedata[this.index_form].customform',
            this.typedata[this.index_form].customform
          )
          await this.getdepaprojectformbyid(this.typedata[this.index_form].customform)
        }
      }
      this.$forceUpdate()
    },
    async getDepaapplicantStatus() {
      const data = {
        applicantId: this.currentdata.applicantid
      }
      const res = await api.getDepaapplicantStatus(data)
      this.stepResult = res.stepResult
      if (
        res.applicantstatus === 'waiting list' ||
        res.applicantstatus === 'สมัครเข้าร่วมโครงการ'
      ) {
        this.applicantstatus = '1'
      } else if (res.applicantstatus === 'รอเอกสาร') {
        this.applicantstatus = '2'
      } else if (res.applicantstatus === 'รอการพิจารณา') {
        this.applicantstatus = '3'
      } else if (
        res.applicantstatus === 'อนุมัติการสมัครเข้าร่วมโครงการ' ||
        res.applicantstatus === 'ไม่อนุมัติการสมัครเข้าร่วมโครงการ'
      ) {
        this.applicantstatus = '4'
      }
    },
    async getdepaprojectbyid() {
      const getprojectId = await api.getdepaprojectbyid({ projectid: this.currentdata.projectid })
      this.typedata = JSON.parse(getprojectId[0].data[0].typedata)[0].steps
      this.projectdata = JSON.parse(getprojectId[0].data[0].projectdata)
      this.typedata.map((item, key) => {
        // this.currentPage.push(0)
        this.totalPage.push(0)
      })
      this.$forceUpdate()
    },
    async getdepaprojectformbyid(data) {
      const getdepaprojectformbyid = await api.getdepaprojectformbyid({ customform: data })

      this.formShow = JSON.parse(getdepaprojectformbyid[0].data[0].formdata)
      this.nameForm = getdepaprojectformbyid[0].data[0].formname
      this.$forceUpdate()
    },
    async getProductMember() {
      const getProductMember = await api.getProductMember(this.currentdata.memberid)
      this.productMember = getProductMember
    },
    async summitProduct(k) {
      this.addProductData.techprovider = this.currentdata.techproviderid
      const data = {}
      data.img = this.addProductData.img
      data.productname = this.addProductData.productname
      data.producttype = this.addProductData.producttype ? this.addProductData.producttype : null
      data.description = this.addProductData.description ? this.addProductData.description : null
      data.deviceversion = this.addProductData.deviceversion
        ? this.addProductData.deviceversion
        : null
      data.workchannel = this.addProductData.workchannel ? this.addProductData.workchannel : null
      data.service = this.addProductData.service ? this.addProductData.service : null
      data.otherdetail = this.addProductData.otherdetail ? this.addProductData.otherdetail : null
      data.price = this.addProductData.price
      data.discountprice = this.addProductData.discountprice ? this.addProductData.discountprice : null
      data.campaignid = this.addProductData.campaignid
      data.salesrepresentatives = this.addProductData.salesrepresentatives
      data.categoryid = this.addProductData.categoryid
      data.tags = this.addProductData.tags
      data.copyrighttype = this.addProductData.copyrighttype
      data.techprovider = this.addProductData.techprovider
      data.tagid = this.addProductData.tagid
      const summitProduct = await api.createProduct(data)
      this.allform[k].value2 = summitProduct
      this.getProductMember()
      this.closeModalAddpProductMember()
    },
    openModalAddpProductMember() {
      this.addProductData.img = ''
      this.addProductData.productname = ''
      this.addProductData.producttype = 'hardware'
      this.addProductData.description = ''
      this.addProductData.deviceversion = ''
      this.addProductData.workchannel = ''
      this.addProductData.service = ''
      this.addProductData.otherdetail = ''
      this.addProductData.price = ''
      this.addProductData.discountprice = ''
      this.addProductData.campaignid = ''
      this.addProductData.salesrepresentatives = ''
      this.addProductData.categoryname = ''
      this.addProductData.categoryid = 0
      this.addProductData.typename = ''
      this.addProductData.typeid = ''
      this.addProductData.tags = ''
      this.addProductData.tagid = 0
      this.addProductData.copyrighttype = ''
      this.modalAddpProductMember = true
      this.getCampaign()
      this.getCategory()
      this.getProductTags()
      this.getProductTag()
      this.$forceUpdate()
    },
    closeModalAddpProductMember() {
      this.modalAddpProductMember = false
      this.$forceUpdate()
    },
    async summitEditProduct(k) {
      this.addProductData.techprovider = this.currentdata.techproviderid
      const data = {}
      data.img = this.addProductData.img
      data.productname = this.addProductData.productname
      data.producttype = this.addProductData.producttype ? this.addProductData.producttype : null
      data.description = this.addProductData.description ? this.addProductData.description : null
      data.deviceversion = this.addProductData.deviceversion
        ? this.addProductData.deviceversion
        : null
      data.workchannel = this.addProductData.workchannel ? this.addProductData.workchannel : null
      data.service = this.addProductData.service ? this.addProductData.service : null
      data.otherdetail = this.addProductData.otherdetail ? this.addProductData.otherdetail : null
      data.price = this.addProductData.price ? this.addProductData.price : null
      data.discountprice = this.addProductData.discountprice ? this.addProductData.discountprice : null
      data.campaignid = this.addProductData.campaignid.toString()
      data.salesrepresentatives = this.addProductData.salesrepresentatives
      data.categoryid = this.addProductData.categoryid
      data.tags = this.addProductData.tags
      data.copyrighttype = this.addProductData.copyrighttype
      data.techprovider = this.addProductData.techprovider
      data.tagid = this.addProductData.tagid
      data.productid = this.allform[k].value2.productid
      const productid = this.allform[k].value2.productid
      const editProduct = await api.editProduct(data, productid)
      this.allform[k].value2 = data
      this.getProductMember()
      this.closeModalEditProductMember()
    },
    async openModalEditProductMember(k) {
      await this.getCampaign()
      await this.getCategory()
      await this.getProductTags()
      await this.getProductTag()
      //this.productMember

      let data = this.productMember.filter((item) => {
        return (
          item.productid ==   this.allform[k].value2.productid 
      )});
      
      // const res = await api.getProductMember(memberid)
      this.addProductData.productid = this.allform[k].value2.productid
      this.addProductData.img = data[0].img
      this.addProductData.productname = data[0].productname
      this.addProductData.producttype = data[0].producttype
      this.addProductData.description = data[0].description
      this.addProductData.deviceversion = data[0].deviceversion
      this.addProductData.workchannel = data[0].workchannel
      this.addProductData.service = data[0].service
      this.addProductData.otherdetail = data[0].otherdetail
      this.addProductData.price = data[0].price
      this.addProductData.discountprice = data[0].discountprice
      this.addProductData.campaignid = parseInt(data[0].campaignid)
      this.addProductData.salesrepresentatives = data[0].salesrepresentatives
      this.addProductData.categoryname = data[0].categoryname
      this.addProductData.categoryid = data[0].categoryid
      this.addProductData.typename = data[0].typename
      this.addProductData.typeid = data[0].typeid
      this.addProductData.tags = data[0].tags
      this.addProductData.tagid = data[0].tagid
      this.addProductData.copyrighttype = data[0].copyrighttype
        if(this.addProductData.typename){
          this.changType()
        }
      this.modalEditProductMember = true

      this.$forceUpdate()
    },
    closeModalEditProductMember() {
      this.addProductData.img = ''
      this.addProductData.productname = ''
      this.addProductData.producttype = 'hardware'
      this.addProductData.deviceversion = ''
      this.addProductData.workchannel = ''
      this.addProductData.service = ''
      this.addProductData.otherdetail = ''
      this.addProductData.price = ''
      this.addProductData.discountprice = ''
      this.addProductData.campaignid = ''
      this.addProductData.salesrepresentatives = ''
      this.addProductData.categoryname = ''
      this.addProductData.categoryid = 0
      this.addProductData.typename = ''
      this.addProductData.typeid = ''
      this.addProductData.tags = ''
      this.addProductData.tagid = 0
      this.addProductData.copyrighttype = ''

      this.modalEditProductMember = false
      this.$forceUpdate()
    },
    async getCampaign() {
      const data = await api.getCampaign()
      if (data.length) {
        this.addProductcampaign = data
      }
    },
    async getCategory() {
      const data = await api.getCategory()
      if (data) {
        data.data.map((item, index) => {
          this.addProducttypename.push(item)
        })
      }
    },
    changType() {
      this.addProducttypename.map((item, key) => {
        if (item.typename === this.addProductData.typename) {
          this.addProductData.typeid = item.typeid
          this.addProductcategory = item.categories
        }
      })
    },
    changEditType(k) {
      this.addProducttypename.map((item, key) => {
        if (item.typename === this.addProductData.typename) {
          this.addProductData.typeid = item.typeid
          this.addProductcategory = item.categories
        }
      })
    },
    changCategory() {
      this.addProductcategory.map((item, key) => {
        if (item.categoryname === this.addProductData.categoryname) {
          this.addProductData.categoryid = item.categoryid
        }
      })
    },
    changTagId() {
      this.addProducttagId.map((item, key) => {
        console.log('item', item)
        // if (item.categoryname === this.addProductData.tagid) {
        //   this.addProductData.tagid = item.categoryid
        // }
      })
    },
    async getProductTags() {
      const data = await api.getProductTags()
      this.addProducttag = data
      //addProducttag
    },
    async getProductTag() {
      const data = await api.getProductTagId()
      this.addProducttagId = data.data
      //addProducttag
    },
    addTag(newTag) {
      this.addProductData.tags = this.allTags.join(',')
    },
    toggleModalRejectApplication() {
      this.modalRejectApplication = !this.modalRejectApplication
    },
    async depaConfirmapplication() {
      const current_step = this.typedata[this.index_form]
      const next_step = this.typedata[this.index_form + 1]
      let data = {
        tags: this.projectdata[this.index_form].tags ? this.projectdata[this.index_form].tags : '',
        dpType: this.projectdata[this.index_form].dpType
          ? this.projectdata[this.index_form].dpType
          : '',
        userid: '',
        memberid: this.currentdata.memberid,
        projectid: this.currentdata.projectid,
        formid: current_step.customform,
        // formdata: JSON.stringify({
        //   formitems: [...this.allform, this.allform.map((item) => {
        //     if (item.questiontype === 'ที่อยู่') {
        //       return item.value = JSON.stringify(item.value)
        //     }
        //   })
        //   ],
        //   formname: this.nameForm,
        //   button: this.formShow.button,
        //   reject: this.formShow.reject
        // }),
        formdata: JSON.stringify({
          formitems: _.cloneDeep(this.allform).map(item => {
            if (item.questiontype === 'ที่อยู่') {
              item.value = JSON.stringify(item.value)
            }
            return item
          }),
          formname: this.nameForm,
          button: this.formShow.button,
          reject: this.formShow.reject
        }),
        current_stepid: current_step.id,
        next_stepid: next_step ? next_step.id : '',
        applicantid: this.currentdata.applicantid,
        confirmproject: true,
        rejectMessage: ''
      }
      const res = await api.depaconfirmapplication(data)
      this.getDepaapplicantStatus()
      this.$emit('loadtable')
    },
    async depaRejectapplication() {
      const current_step = this.typedata[this.index_form]
      const next_step = this.typedata[this.index_form + 1]

      let data = {
        tags: this.projectdata[this.index_form].tags ? this.projectdata[this.index_form].tags : '',
        dpType: this.projectdata[this.index_form].dpType
          ? this.projectdata[this.index_form].dpType
          : '',
        userid: '',
        memberid: this.currentdata.memberid,
        projectid: this.currentdata.projectid,
        formid: current_step.customform,
        formdata: JSON.stringify({
          formitems: _.cloneDeep(this.allform).map(item => {
            if (item.questiontype === 'ที่อยู่') {
              item.value = JSON.stringify(item.value)
            }
            return item
          }),
          formname: this.nameForm,
          button: this.formShow.button,
          reject: this.formShow.reject
        }),
        current_stepid: current_step.id,
        next_stepid: next_step ? next_step.id : '',
        applicantid: this.currentdata.applicantid,
        confirmproject: false,
        rejectMessage: this.rejectMessageApplication
      }
      const res = await api.depaconfirmapplication(data)
      this.getDepaapplicantStatus()
      this.toggleModalRejectApplication()
      this.$emit('loadtable')
    },
    toggleModalAllApplication() {
      this.modalAllApplication = !this.modalAllApplication
    },
    async confirmApplication() {
      const lengthData = this.typedata.length
      const current_step = this.typedata[this.index_form]
      const last_step = this.typedata[lengthData - 1]
      this.typedata[this.index_form].customform
      const getForm = await api.getdepaprojectformbyid({
        customform: this.typedata[lengthData - 1].customform
      })
      const lastForm = JSON.parse(getForm[0].data[0].formdata)
      // formdata: JSON.stringify({
      //     formitems: _.cloneDeep(this.allform).map(item => {
      //       if (item.questiontype === 'ที่อยู่') {
      //         return (item.value = JSON.stringify(item.value))
      //       }
      //     }),
      //     formname: this.nameForm,
      //     button: this.formShow.button,
      //     reject: this.formShow.reject
      //   }),
      
      const dataFormdata = {
        formitems:
          current_step.id === last_step.id && lengthData - 1 === 0
            ? _.cloneDeep(this.data[0].formitems).map(item => {
                if (item.questiontype === 'ที่อยู่') {
                  item.value = JSON.stringify(item.value)
                }
                return item
              })
          : current_step.id === last_step.id 
            ? _.cloneDeep(this.allform).map(item => {
                if (item.questiontype === 'ที่อยู่') {
                  item.value = JSON.stringify(item.value)
                }
                return item
              })
          : lastForm.formitems,
        formname: current_step.id === last_step.id ? this.nameForm : getForm[0].data[0].formname,
        button: lastForm.button,
        reject: lastForm.reject
      }
      let data = {
        tags: this.projectdata[this.index_form].tags ? this.projectdata[this.index_form].tags : '',
        dpType: this.projectdata[this.index_form].dpType
          ? this.projectdata[this.index_form].dpType
          : '',
        userid: '',
        memberid: this.currentdata.memberid,
        projectid: this.currentdata.projectid,
        formid: last_step.customform,
        formdata: JSON.stringify(dataFormdata),
        current_stepid: last_step.id,
        next_stepid: '',
        applicantid: this.currentdata.applicantid,
        confirmproject: true,
        rejectMessage: ''
      }
     const res = await api.depaconfirmapplication(data)
      this.getDepaapplicantStatus()
    },
    async rejectApplication() {
      const lengthData = this.typedata.length
      const current_step = this.typedata[this.index_form]
      const last_step = this.typedata[lengthData - 1]
      this.typedata[this.index_form].customform
      const getForm = await api.getdepaprojectformbyid({
        customform: this.typedata[lengthData - 1].customform
      })
      const lastForm = JSON.parse(getForm[0].data[0].formdata)
      const dataFormdata = {
        formitems:
          current_step.id === last_step.id && lengthData - 1 === 0
            ? _.cloneDeep(this.data[0].formitems).map(item => {
                if (item.questiontype === 'ที่อยู่') {
                  item.value = JSON.stringify(item.value)
                }
                return item
              })
          : current_step.id === last_step.id 
            ? _.cloneDeep(this.allform).map(item => {
                if (item.questiontype === 'ที่อยู่') {
                  item.value = JSON.stringify(item.value)
                }
                return item
              })
          : lastForm.formitems,
        formname: current_step.id === last_step.id ? this.nameForm : getForm[0].data[0].formname,
        button: lastForm.button,
        reject: lastForm.reject
      }
      let data = {
        tags: this.projectdata[this.index_form].tags ? this.projectdata[this.index_form].tags : '',
        dpType: this.projectdata[this.index_form].dpType
          ? this.projectdata[this.index_form].dpType
          : '',
        userid: '',
        memberid: this.currentdata.memberid,
        projectid: this.currentdata.projectid,
        formid: current_step.customform,
        formdata: JSON.stringify(dataFormdata),
        current_stepid: current_step.id,
        next_stepid: '',
        applicantid: this.currentdata.applicantid,
        confirmproject: false,
        rejectMessage: this.rejectMessageAllApplication
      }
      const res = await api.depaconfirmapplication(data)
      this.getDepaapplicantStatus()
      this.toggleModalAllApplication()
    },
    async summitConsider() {
      const data = {
        applicantId: this.currentdata.applicantid
      }
      const res = await api.postDepaapplicantConsider(data)
      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">ส่งตรวจสอบสำเร็จ</div>',
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
      })
      await this.getDepaapplicantStatus()
    },
    toggleModalDepasendReport() {
      this.modalDepasendReport = !this.modalDepasendReport
    },
    async summitDepasendReport() {
      const data = {
        applicantid: this.currentdata.applicantid,
        memberid: this.currentdata.memberid,
        projectid: this.currentdata.projectid,
        text: this.sendReportData.text,
        sendForm: this.sendReportData.sendForm ? true : false,
        isRequestDoc: true //
      }
      const res = await api.postDepasendReport(data)
      this.getDepaapplicantStatus()
      this.toggleModalDepasendReport()
      if (res == undefined) {
        this.$swal.fire({
          type: 'error',
          title: '<div class="headline primary--text bold7 fs-24">ขอเอกสารไม่สำเร็จ</div>',
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
        return
      }
      if (res.responsecode == 200) {
        this.$swal.fire({
          type: 'success',
          title: '<div class="headline primary--text bold7 fs-24">ขอเอกสารสำเร็จ</div>',
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      } else {
        this.$swal.fire({
          type: 'error',
          title: '<div class="headline primary--text bold7 fs-24">ขอเอกสารไม่สำเร็จ</div>',
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      }
    },
    async deparesendnotifyformbystepid() {
      const lengthData = this.typedata.length
      const current_step = this.typedata[lengthData - 1]
      const data = {
        applicantid: this.currentdata.applicantid,
        stepid: current_step.id,
        text: ''
      }

      const res = await api.deparesendnotifyformbystepid(data)

      if (res) {
        this.$swal.fire({
          type: 'success',
          title: '<div class="headline primary--text bold7 fs-24">resend เรียบร้อยแล้ว</div>',
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
        return
      } else {
        this.$swal.fire({
          type: 'error',
          title: '<div class="headline primary--text bold7 fs-24">resend ไม่สำเร็จ</div>',
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      }
    },
    goToLivechat: function() {
      if (this.currentdata.userid === null) {
        this.$swal.fire({
          type: 'error',
          title:
            '<div class="headline primary--text bold7 fs-24">ผู้สมัครไม่ได้เชื่อมต่อ Line</div>',
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
        return
      }
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: this.currentdata.userid
        }
      })
      window.open(routeData.href, '_blank')
    }
  },
  filters: {
    showFilename(value) {
      var result = value

      if (result && !Array.isArray(result)) {
        result = result.split('/')
        result = result[4].substring(13)
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.bg-green {
  background-color: #b8dba8;
}
.bg-red {
  background-color: #d7aaaa;
}
.flex-input {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.header-form {
  font-weight: 600;
  font-size: 16px;
  color: #2c2c2c;
}
.input-form {
  height: 38px !important;
  width: 100% !important;
  background: #ffffff !important;
  border: 1px solid #2c2c2c !important;
  border-radius: 6px !important;
  padding-left: 14px !important;
  color: #26588b !important;
  outline: none !important;
  box-shadow: none !important;
  margin-bottom: 0px !important;
}
.input-form-modal {
  height: 38px !important;
  width: 97%;
  background: #ffffff !important;
  border: 1px solid #2c2c2c !important;
  border-radius: 6px !important;
  padding-left: 14px !important;
  color: #26588b !important;
  outline: none !important;
  box-shadow: none !important;
  margin-bottom: 0px !important;
}

.button-select {
  background: #ffffff;
  border: 1px solid #2c2c2c !important;
  border-radius: 6px !important;
  /* height: 38px; */
  outline: none;
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.form-detailmember {
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.input-focus:focus {
  border-bottom: 0px solid #9e9e9e;
  border: none !important;
  outline: none;
  box-shadow: 0 0px 0 0 #000 !important;
}
.cricle-box-active {
  background: #0c2f53;
  color: #ffef01;
  border-radius: 100%;
  width: 32px;
  height: 32px;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-active {
  color: #0c2f53;
}
.center-line-active {
  width: 90%;
  height: 2px;
  background-color: #0c2f53;
}
.cricle-box-disable {
  border: 1px solid rgba(0, 0, 0, 0.25);
  background: #fff;
  color: rgba(0, 0, 0, 0.25);
  border-radius: 100%;
  width: 32px;
  height: 32px;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-disable {
  color: rgba(0, 0, 0, 0.25);
}
.center-line-disable {
  width: 90%;
  height: 2px;
  background-color: #f0f0f0;
}
.footer-formDetailMember {
  position: fixed;
  bottom: 0px;
  height: 80px;
  width: 800px;
  background: #ffffff;
  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 0px 0px 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 40px;
}
.btn-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 14px;
}
.btn-summit {
  background: #0c2f53 !important;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #ffef01 !important;
  font-weight: 700;
  font-size: 16px;
}
.btn-cancel {
  background: #ffffff !important;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #0c2f53 !important;
  font-weight: 700;
  font-size: 16px;
}

.generate-table-container {
  width: 100%;
  max-height: 350px;
  overflow-x: auto;
  overflow-y: auto;
}
.generate-table-container::-webkit-scrollbar {
  -webkit-appearance: none;
  background: #eeeeee;
  border-radius: 20px;
}
.generate-table-container::-webkit-scrollbar:vertical {
  width: 13px;
}

.generate-table-container::-webkit-scrollbar:horizontal {
  height: 13px;
}

.generate-table-container::-webkit-scrollbar-thumb {
  border-radius: 20px;
  border: 3px solid #eeeeee;
  background-color: #0c2f53;
}
table.form-generate-table {
  table-layout: fixed;
  width: max-content;
  thead {
    tr {
      border-bottom: 1px solid #d9d9d9;
      th {
        width: 162px;
        padding: 8px 0px;
        position: relative;
        border-radius: 0px;
        background-color: #eeeeee;
        img.table-ico {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      th:first-child {
        background-color: #bdbdbd;
      }
      th:not(:first-child)::after {
        content: '';
        border-left: 1px solid #d9d9d9;
        position: absolute;
        height: 50%;
        left: 0;
        top: 25%;
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #d9d9d9;
      td {
        padding: 8px 0px;
        border-radius: 0px;
        position: relative;
        img.table-ico {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      td:first-child {
        background-color: #eeeeee;
      }
      td:not(:first-child)::after {
        content: '';
        border-left: 1px solid #d9d9d9;
        position: absolute;
        height: 50%;
        left: 0;
        top: 25%;
      }
    }
  }
}
.customConfirmBtn {
  color: yellow !important;
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}
.dataReq {
  display: flex;
}
.dataReq::after {
  content: '*';
  color: red;
}
.uploadBtn {
  width: 185px;
}
.customInfoBtn {
  width: 142px;
  background-color: #e6f0fb !important;
  color: #0c2f53 !important;
  border: 1px solid #0c2f53 !important;
  font-weight: 700;
  font-size: 16px;
}
.customRejectBtn {
  width: 142px;
  background-color: #ffffff !important;
  color: #0c2f53 !important;
  border: 1px solid #0c2f53 !important;
  font-weight: 700;
  font-size: 16px;
}
.customApproveBtn {
  width: 142px;
  color: #ffef01 !important;
  border-color: #0c2f53 !important;
  background-color: #0c2f53 !important;
  font-weight: 700;
  font-size: 16px;
}
.customDisableBtn {
  opacity: 0.4;
}
.customExamfileBtn {
  background-color: #e6f0fb !important;
  color: #26588b !important;
  font-weight: 700;
  font-size: 16px;
  width: 165px;
  .customBtnText {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.text-box-header {
  font-weight: 400 !important;
  font-size: 16px !important;
  color: #0c2f53 !important;
  min-width: 100px !important;
}
.text-box-subheader {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #0c2f53;
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/FormDetailMember.vue